import Model from '@/models/Model'

export default class AccAccountingSeatStatus extends Model {
    resource() {
        return 'acc_accounting_seat_status'
    }
}